/**
 * Google Maps の共通設定
 *
 * APIキーとMap IDは環境変数から読み込む。
 * APIキーはブラウザに露出するため、GCP側でHTTPリファラ制限を必ず設定すること。
 */

export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY ?? ''

/** Advanced Marker とクラウドスタイリングに必要。未設定時はGoogle提供のデモIDにフォールバック */
export const GOOGLE_MAPS_MAP_ID = import.meta.env.VITE_GOOGLE_MAPS_MAP_ID || 'DEMO_MAP_ID'

/** 地図の既定中心（東京駅周辺） */
export const DEFAULT_MAP_CENTER: google.maps.LatLngLiteral = { lat: 35.6762, lng: 139.6503 }

export const isGoogleMapsConfigured = (): boolean => GOOGLE_MAPS_API_KEY.length > 0

/**
 * 16進カラーコードに不透明度を適用してrgba文字列に変換
 * LeafletのfillOpacity（塗りのみに効く）を再現するために使用
 */
export function hexToRgba(hex: string, alpha: number): string {
  const normalized = hex.replace('#', '')
  const full =
    normalized.length === 3
      ? normalized
          .split('')
          .map((c) => c + c)
          .join('')
      : normalized
  const value = Number.parseInt(full, 16)
  if (Number.isNaN(value)) return hex

  const r = (value >> 16) & 0xff
  const g = (value >> 8) & 0xff
  const b = value & 0xff
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
